export const isNetworkError = (err) =>
  !err?.response || err?.code === "ERR_NETWORK" || err?.message === "Network Error";
